import { DndProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import React, { ReactNode } from 'react';
import Box from '@mui/material/Box';
import { Services } from './Services';

const DndProviderComponent = ({ schema, values }) => {
  return (
    <>
      <DndProvider backend={HTML5Backend}>
        <Services schema={schema} values={values} />
      </DndProvider>
    </>
  );
};

export default DndProviderComponent;
